// src/ga/index.js
import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = "G-D7HH05B0KP";

export const initGA = () => {
  ReactGA.initialize(GA_MEASUREMENT_ID);
};

export const trackPageview = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};